import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import StopClusterMap from './components/StopClusterMap';
import LiveDepartureActions from '../../redux/LiveDeparture';
import { getStops } from '../../services/GtfsService';
import ShapeOfTypes from '../../utils/ShapeOfTypes';
import { ADDRESS_CATEGORIES } from '../../constants/addressCategories';

class StopClusterMapContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stops: [],
    };
    this.closeMap = this.closeMap.bind(this);
    this.selectStop = this.selectStop.bind(this);
  }

  componentDidMount() {
    getStops().then((stops) => {
      const parentStopIds = stops.reduce((result, stop) => {
        if (stop.parent_station !== null && !result.includes(stop)) {
          return result.concat(stop.parent_station);
        }
        return result;
      }, []);

      const filteredStops = stops.filter((stop) => {
        if (stop.location_type === 0 && stop.parent_station !== null) {
          return false;
        }
        if (parentStopIds.includes(stop.stop_id)) {
          return true;
        }
        return stop.location_type === 0;
      });

      this.setState({ stops: filteredStops });
    });
  }

  closeMap() {
    const { selectAddress } = this.props;
    selectAddress(null);
  }

  selectStop(stop) {
    const { selectAddress } = this.props;
    selectAddress({
      address: `${stop.stop_code} - ${stop.stop_name}`,
      category: ADDRESS_CATEGORIES.BUSSTOP,
      lat: stop.stop_lat,
      lng: stop.stop_lon,
    });
  }

  render() {
    const {
      mapEnabled,
      selectedAddress,
      enableAccessibilityOutlines,
    } = this.props;
    const { stops } = this.state;
    return mapEnabled && <StopClusterMap onClose={this.closeMap} selectedAddress={selectedAddress} selectStop={this.selectStop} stops={stops} enableAccessibilityOutlines={enableAccessibilityOutlines} />;
  }
}
StopClusterMapContainer.propTypes = {
  mapEnabled: PropTypes.bool.isRequired,
  selectAddress: PropTypes.func.isRequired,
  enableAccessibilityOutlines: PropTypes.func,
  selectedAddress: ShapeOfTypes.Address,
};
StopClusterMapContainer.defaultProps = {
  selectedAddress: null,
  enableAccessibilityOutlines: () => { /* default empty function */ },
};
const mapStateToProps = ({ liveDeparture }) => ({
  mapEnabled: liveDeparture.mapEnabled,
  selectedAddress: liveDeparture.selection,
});
const mapDispatchToProps = dispatch => ({
  selectAddress: selection => dispatch(LiveDepartureActions.selectAddress(selection)),
});
export default connect(mapStateToProps, mapDispatchToProps)(StopClusterMapContainer);
